import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { Procedure } from 'types/procedure';

type ProcedureItemModuleProps = {
  procedure: Procedure;
};

const ProcedureItemModule: React.FC<ProcedureItemModuleProps> = ({ procedure }) => {
  return (
    <ModuleCard
      idLabel={`ID ${procedure.id}`}
      title={procedure.name}
      subtitle="Consulta"
      status={procedure.formattedActive}
      statusTone={procedure.active ? 'success' : 'error'}
      metrics={[
        { label: 'Preço de venda', value: procedure.formattedSalePrice, tone: 'primary' },
        { label: 'Comissão', value: procedure.formattedCommission, tone: 'success' },
      ]}
      onClick={() => history.push(`/consultation/${procedure.id}`)}
    />
  );
};

export default ProcedureItemModule;
